import React from 'react'
import styled from 'styled-components'
import { useScreenSize } from '../../../hooks/useScreenSize'

const Container = styled.div`
    text-align: justify;
    padding: .5rem;
    width: ${props => props.fullWidth ? '90vw' : '50vw'};

    .container-text{
        height: 60vh;
        overflow-y: auto;
    }
    
    h2{
        font-size: 1.5rem;
        font-weight: 900;
        text-align: center;
    }

    .subtitle-center{
        text-align: center;
        font-style: italic;
        margin-bottom: 1rem;
    }
    
    .sub-title{
        font-size: 1.2rem;
        font-weight: 900;
        margin-top: 1.5rem;
    }

    .header-info{
        text-align: center;
        margin-bottom: 1rem;
    }

    ul{
        margin-left: 2rem;
    }
`

export const PrivacyPolicy = () => {
    const { width } = useScreenSize()

    return (
        <Container fullWidth={width < 700}>
            <div className='header-info'>
                <h2>MUNICIPIO DE DELICIAS, CHIHUAHUA</h2>
                <div className='subtitle-center'>Dirección de Innovación y Tecnología</div>
            </div>
            
            <h2>POLÍTICA DE PRIVACIDAD</h2>
            <div className='subtitle-center'>
                <strong>Aplicación Móvil: Delicias Touch</strong><br/>
                Fecha de última actualización: 07 de abril de 2026
            </div>

            <div className='container-text'>
                <div className='sub-title'>1. Introducción</div>
                <p>
                    El Municipio de Delicias, Chihuahua, a través de la Dirección de Innovación y Tecnología, es el responsable del tratamiento de los datos personales recopilados mediante la aplicación móvil Delicias Touch. Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos la información personal de nuestros usuarios, en cumplimiento con la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados (LGPDPPSO) y demás normativa aplicable.
                </p>
                <p>
                    Al utilizar la aplicación Delicias Touch, usted acepta las prácticas descritas en este documento.
                </p>

                <div className='sub-title'>2. Responsable del Tratamiento de Datos</div>
                <p>
                    <strong>Nombre:</strong> Municipio de Delicias, Chihuahua<br/>
                    <strong>Domicilio:</strong> Palacio Municipal, Avenida Manuel Acuña #300, Centro, Delicias, Chihuahua, C.P. 33000<br/>
                    <strong>Correo de contacto:</strong> privacidad@delicias.gob.mx<br/>
                    <strong>Sitio web:</strong> www.delicias.gob.mx
                </p>

                <div className='sub-title'>3. Datos Personales que Recopilamos</div>
                <p>
                    Para el correcto funcionamiento de la aplicación Delicias Touch, recopilamos los siguientes datos personales de los ciudadanos:
                </p>
                <ul>
                    <li>Nombre completo</li>
                    <li>Clave Única de Registro de Población (CURP)</li>
                    <li>Número de teléfono</li>
                    <li>Correo electrónico</li>
                    <li>Domicilio</li>
                    <li>Código postal</li>
                    <li>Ubicación GPS (al momento de registrar un reporte)</li>
                    <li>Fotografías adjuntas a reportes ciudadanos</li>
                </ul>
                <p>
                    Estos datos son proporcionados directamente por el usuario al momento de registrarse en la aplicación o al realizar un reporte de servicio público.
                </p>

                <div className='sub-title'>4. Finalidad del Tratamiento de Datos</div>
                <p>
                    Los datos personales recopilados son utilizados exclusivamente para los siguientes fines:
                </p>
                <ul>
                    <li>Identificar y autenticar a los ciudadanos registrados en la plataforma.</li>
                    <li>Gestionar y dar seguimiento a reportes de servicios públicos (baches, alumbrado, limpieza, fugas, entre otros).</li>
                    <li>Enviar notificaciones sobre el estado de los reportes presentados.</li>
                    <li>Verificar la elegibilidad del ciudadano para participar en el sistema de presupuesto participativo.</li>
                    <li>Mejorar la calidad y cobertura de los servicios municipales.</li>
                    <li>Generar estadísticas anónimas para la planeación municipal.</li>
                </ul>

                <div className='sub-title'>5. Base Legal del Tratamiento</div>
                <p>
                    El tratamiento de sus datos personales se realiza con fundamento en:
                </p>
                <ul>
                    <li>El ejercicio de las atribuciones del Municipio de Delicias en materia de servicios públicos.</li>
                    <li>La Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados.</li>
                    <li>El consentimiento explícito del titular al momento del registro en la aplicación.</li>
                </ul>

                <div className='sub-title'>6. Compartición de Datos con Terceros</div>
                <p>
                    El Municipio de Delicias <strong>NO</strong> comparte, vende, cede ni transfiere sus datos personales a terceros con fines comerciales.
                </p>
                <p>
                    Sus datos son utilizados únicamente de manera interna por el personal municipal autorizado para la gestión de reportes y servicios ciudadanos.
                </p>
                <p>
                    Excepcionalmente, podremos compartir información cuando sea requerida por autoridad competente mediante orden judicial o mandato legal, en cuyo caso se notificará al usuario en la medida permitida por la ley.
                </p>
                <p>
                    La aplicación utiliza servicios de infraestructura tecnológica de Firebase (Google LLC) para el envío de notificaciones push. Firebase actúa como encargado del tratamiento bajo nuestras instrucciones y no accede al contenido de sus datos personales.
                </p>

                <div className='sub-title'>7. Tiempo de Conservación de los Datos</div>
                <p>
                    Sus datos personales serán conservados durante el tiempo que mantenga una cuenta activa en la aplicación y por el período adicional que establezca la normativa aplicable en materia de archivo y documentación gubernamental.
                </p>
                <p>
                    Una vez concluida la relación y transcurridos los plazos legales, sus datos serán eliminados o anonimizados de forma segura.
                </p>

                <div className='sub-title'>8. Medidas de Seguridad</div>
                <p>
                    El Municipio de Delicias implementa medidas técnicas, administrativas y físicas para proteger sus datos personales contra pérdida, robo, uso no autorizado, alteración o destrucción, incluyendo:
                </p>
                <ul>
                    <li>Cifrado de datos en tránsito mediante protocolos HTTPS/TLS.</li>
                    <li>Almacenamiento seguro en servidores con acceso restringido.</li>
                    <li>Control de acceso basado en roles para el personal municipal.</li>
                    <li>Monitoreo continuo de los sistemas de información.</li>
                </ul>

                <div className='sub-title'>9. Derechos del Titular (Derechos ARCO)</div>
                <p>
                    Como titular de sus datos personales, usted tiene derecho a:
                </p>
                <ul>
                    <li><strong>Acceso:</strong> Conocer qué datos personales tenemos sobre usted y cómo los utilizamos.</li>
                    <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos o incompletos.</li>
                    <li><strong>Cancelación:</strong> Pedir la eliminación de sus datos cuando ya no sean necesarios.</li>
                    <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos en casos específicos.</li>
                </ul>
                <p>
                    Para ejercer cualquiera de estos derechos, puede enviar una solicitud por escrito al correo privacidad@delicias.gob.mx o acudir personalmente al Palacio Municipal de Delicias, Chihuahua, presentando identificación oficial. Su solicitud será atendida en un plazo máximo de 20 días hábiles.
                </p>

                <div className='sub-title'>10. Permisos Requeridos por la Aplicación</div>
                <p>
                    La aplicación Delicias Touch solicita los siguientes permisos en su dispositivo móvil:
                </p>
                <ul>
                    <li><strong>Ubicación:</strong> Para geolocalizar los reportes ciudadanos. Solo se activa cuando el usuario registra un reporte.</li>
                    <li><strong>Cámara y galería de fotos:</strong> Para adjuntar evidencias fotográficas a los reportes.</li>
                    <li><strong>Notificaciones push:</strong> Para informarle sobre el estado de sus reportes.</li>
                </ul>
                <p>
                    Ninguno de estos permisos es utilizado para fines distintos a los mencionados.
                </p>

                <div className='sub-title'>11. Usuarios Menores de Edad</div>
                <p>
                    La aplicación Delicias Touch está destinada a ciudadanos mayores de 18 años. No recopilamos intencionalmente datos personales de menores de edad. Si usted es padre, madre o tutor y tiene conocimiento de que un menor ha proporcionado datos en nuestra aplicación, le pedimos que nos lo notifique para proceder con su eliminación.
                </p>

                <div className='sub-title'>12. Cambios a esta Política de Privacidad</div>
                <p>
                    El Municipio de Delicias se reserva el derecho de actualizar esta Política de Privacidad en cualquier momento. Cualquier cambio significativo será notificado a través de la aplicación o mediante correo electrónico. Le recomendamos revisar periódicamente este documento.
                </p>
                <p>
                    La versión más reciente siempre estará disponible dentro de la aplicación Delicias Touch y en el sitio web oficial del municipio.
                </p>

                <div className='sub-title'>13. Contacto</div>
                <p>
                    Si tiene preguntas, comentarios o inquietudes sobre esta Política de Privacidad o sobre el tratamiento de sus datos personales, puede contactarnos a través de:
                </p>
                <ul>
                    <li><strong>Correo electrónico:</strong> <a href="mailto:privacidad@delicias.gob.mx">privacidad@delicias.gob.mx</a></li>
                    <li><strong>Teléfono:</strong> (639) 474-0000</li>
                    <li><strong>Dirección:</strong> Palacio Municipal, Avenida Manuel Acuña #300, Centro, Delicias, Chihuahua, C.P. 33000</li>
                    <li><strong>Horario de atención:</strong> Lunes a viernes de 8:00 a 16:00 horas</li>
                </ul>

                <div style={{ textAlign: 'center', marginTop: '2rem', fontStyle: 'italic' }}>
                    <p>Municipio de Delicias, Chihuahua — Delicias Touch</p>
                    <p>© 2026 Todos los derechos reservados</p>
                </div>
            </div>
        </Container>
    )
}